import React from "react";
import "./MetadataRow.scoped.scss";
import { IMasterDataItem } from "../../../../../interfaces/masterData/masterDataInterfaces";

interface IMetadataRowProps {
  visible: boolean,
  label: string,
  value: string | string[] | undefined,
  metaData?: IMasterDataItem[]
}

const MetadataRow: React.FC<IMetadataRowProps> = ({ visible, label, value, metaData }) => {
  if (!visible
    || value === undefined
    || (Array.isArray(value)
      && value.length === 0)) {
    return null;
  }

  let values: string[] = [];

  if (!Array.isArray(value)) {
    values = [value];
  } else {
    values = value;
  }

    return (
        (label === 'Maintenance Task' && metaData !== undefined) ? 
            <div className="row">
                <label>
                    {label}
                </label>
                <div className="value">
                    {metaData.map(x => (
                        <div
                            className={`tag ${x.active ? "" : "disabledTag"}`}
                            key={`${x.code } - ${x.value}`}
                        >
                            {`${x.code} - ${x.value}`}
                        </div>
                    ))}
                </div>
            </div>
      :
            (<div className="row">
              <label>
                {label}
              </label>
              <div className="value">
                {values.map(x => (
                  <div
                    className="tag"
                    key={x}
                  >
                    {x}
                  </div>
                ))}
              </div>
            </div>)
  );
}

export default MetadataRow;